export const EVENTS = {
    SAVE_EDIT: 'editsavegroup',
    START_EDIT: 'editstartgroup',
    CANCEL_EDIT: 'editcancelgroup',
};
